/* =========================================================
   Coveo cart features for Dawn
   1. Free charger wrap: one wrap (qty 1) whenever the cart has
      any other product; none when the cart has nothing else.
      The shopper picks the color (product page or cart).
   2. Make it a Combo: adds the Clear Screen Protector, tagged
      with the case's phone model, right after Add to bag.
   3. Free delivery progress bar in the cart drawer and cart page.
   ========================================================= */
(function () {
  'use strict';
  if (window.__coveoCart) return;
  window.__coveoCart = true;

  var C = window.CoveoConfig || {};
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var GIFT_PROP = '_coveo_gift';
  var COLOR_KEY = 'coveo-gift-color';
  var DECLINED_KEY = 'coveo-gift-declined';
  var SOURCE = 'coveo';
  var WRAP_ID = Number(C.wrapProductId || 0);
  var AVAILABLE = (C.wraps || []).filter(function (w) { return w.available; }).map(function (w) { return Number(w.id); });

  var store = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { v === null ? sessionStorage.removeItem(k) : sessionStorage.setItem(k, v); } catch (e) {} }
  };

  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    var f = C.moneyFormat || '${{amount}}';
    return f.replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/<[^>]*>/g, '');
  }

  function isWrap(item) { return WRAP_ID && Number(item.product_id) === WRAP_ID; }
  function isQualifying(item) { return !isWrap(item); }
  function preferredId() {
    var saved = Number(store.get(COLOR_KEY));
    if (AVAILABLE.indexOf(saved) !== -1) return saved;
    return Number(C.defaultWrapId) || AVAILABLE[0];
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function postJSON(url, body) {
    return fetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok || d.status) throw new Error(d.description || d.message || url);
        return d;
      });
    });
  }

  /* ---------- keep the drawer, cart page and bubble in step ---------- */
  function isCartPage() { return !!document.querySelector('cart-items#main-cart-items, #main-cart-items'); }

  function refreshUI() {
    if (isCartPage()) { window.location.reload(); return Promise.resolve(); }
    return fetch(ROOT + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();
        var drawerNow = document.querySelector('#CartDrawer');
        if (drawerNow && sections['cart-drawer']) {
          var fresh = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
          if (fresh) drawerNow.innerHTML = fresh.innerHTML;
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var b = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
        return getCart();
      })
      .then(function (cart) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          drawer.classList.toggle('is-empty', cart.item_count === 0);
          var inner = drawer.querySelector('.drawer__inner');
          if (inner) inner.classList.toggle('is-empty', cart.item_count === 0);
        }
        renderExtras(cart);
      })
      .catch(function (e) { console.warn('[coveo]', e); });
  }

  function tellTheme(cart) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: cart });
    }
  }

  /* ---------- the free wrap ---------- */
  var lastGiftKey = null;

  function addGift(variantId) {
    return postJSON('cart/add.js', { items: [{ id: variantId, quantity: 1, properties: { _coveo_gift: '1' } }] })
      .then(getCart)
      .then(function (cart) {
        var w = cart.items.filter(isWrap)[0];
        lastGiftKey = w ? w.key : null;
        return true;
      });
  }

  function sync() {
    if (!WRAP_ID || !AVAILABLE.length) return Promise.resolve(false);
    return getCart().then(function (cart) {
      var wraps = cart.items.filter(isWrap);
      var hasProduct = cart.items.some(isQualifying);

      if (!hasProduct) {
        lastGiftKey = null;
        store.set(DECLINED_KEY, null);
        if (!wraps.length) return false;
        var zero = {};
        wraps.forEach(function (w) { zero[w.key] = 0; });
        return postJSON('cart/update.js', { updates: zero }).then(function () { return true; });
      }

      if (wraps.length) {
        store.set(DECLINED_KEY, null);
        var keep = wraps.filter(function (w) { return w.properties && w.properties[GIFT_PROP] === '1'; })[0] || wraps[0];
        lastGiftKey = keep.key;
        var extra = wraps.filter(function (w) { return w.key !== keep.key; });
        if (keep.quantity === 1 && !extra.length) return false;
        var updates = {};
        updates[keep.key] = 1;
        extra.forEach(function (w) { updates[w.key] = 0; });
        return postJSON('cart/update.js', { updates: updates }).then(function () { return true; });
      }

      // No wrap: if one was there a moment ago, the shopper removed it on purpose.
      if (lastGiftKey) store.set(DECLINED_KEY, '1');
      lastGiftKey = null;
      if (store.get(DECLINED_KEY)) return false;
      return addGift(preferredId());
    });
  }

  function chooseColor(variantId) {
    if (AVAILABLE.indexOf(variantId) === -1) return Promise.resolve(false);
    store.set(COLOR_KEY, String(variantId));
    store.set(DECLINED_KEY, null);
    return getCart().then(function (cart) {
      if (!cart.items.some(isQualifying)) return false;
      var wraps = cart.items.filter(isWrap);
      if (wraps.length === 1 && Number(wraps[0].variant_id) === variantId && wraps[0].quantity === 1) return false;
      var p = Promise.resolve();
      if (wraps.length) {
        var zero = {};
        wraps.forEach(function (w) { zero[w.key] = 0; });
        p = postJSON('cart/update.js', { updates: zero });
      }
      return p.then(function () { return addGift(variantId); });
    });
  }

  /* ---------- Combo ---------- */
  function selectedPhoneModel() {
    var fields = document.querySelectorAll('variant-selects select, variant-selects input[type="radio"]:checked');
    for (var i = 0; i < fields.length; i++) {
      var el = fields[i];
      var name = (el.getAttribute('name') || '').toLowerCase();
      if (name.indexOf('phone model') !== -1 || name.indexOf('device') !== -1) return el.value;
    }
    var label = document.querySelector('[data-coveo-variant-title]');
    return label ? label.getAttribute('data-coveo-variant-title') : '';
  }

  function maybeAddCombo() {
    var box = document.querySelector('[data-coveo-combo] input[type="checkbox"]');
    if (!box || !box.checked || !C.comboVariantId) return Promise.resolve(false);
    var model = selectedPhoneModel();
    var props = {};
    if (model) props['Phone model'] = model;
    return postJSON('cart/add.js', { items: [{ id: Number(C.comboVariantId), quantity: 1, properties: props }] })
      .then(function () { return true; });
  }

  /* ---------- one step at a time ---------- */
  var queue = Promise.resolve();
  function enqueue(task) {
    queue = queue.then(task).catch(function (e) { console.warn('[coveo]', e); return false; });
    return queue;
  }

  function afterCartChange(fromProductForm) {
    enqueue(function () {
      var changed = false;
      var step = fromProductForm ? maybeAddCombo() : Promise.resolve(false);
      return step
        .then(function (c) { changed = changed || c; return sync(); })
        .then(function (c) { changed = changed || c; })
        .then(function () {
          if (changed) return refreshUI().then(getCart).then(tellTheme);
          return getCart().then(renderExtras);
        });
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === SOURCE) return;
      afterCartChange(event && event.source === 'product-form');
    });
  }

  /* ---------- free delivery bar + wrap picker in the cart ---------- */
  function extrasHTML(cart) {
    var html = '';
    var threshold = Number(C.threshold) || 4999;
    var total = cart.total_price;
    var hasProduct = cart.items.some(isQualifying);
    if (!hasProduct) return '';

    var remaining = Math.max(threshold - total, 0);
    var pct = Math.min(100, Math.max(0, (total / threshold) * 100));
    html += '<div class="cv-fsb" role="status">' +
      '<p class="cv-fsb__text">' + (remaining > 0 ? 'Spend ' + money(remaining) + ' more for free delivery.' : 'Your delivery is free.') + '</p>' +
      '<div class="cv-fsb__track" role="progressbar" aria-label="Progress to free delivery" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '"><div class="cv-fsb__fill" style="width:' + pct.toFixed(1) + '%"></div></div>' +
      '</div>';

    if (WRAP_ID && AVAILABLE.length) {
      var current = cart.items.filter(isWrap)[0];
      var currentId = current ? Number(current.variant_id) : null;
      var colors = (C.wraps || []).filter(function (w) { return w.available; });
      var currentName = '';
      colors.forEach(function (w) { if (Number(w.id) === currentId) currentName = w.title; });
      html += '<div class="cv-wrap" data-cv-wrap>' +
        '<div class="cv-wrap__head"><span>Your free charger wrap</span><span class="cv-wrap__price"><span>Free</span><s>' + money(C.wrapCompareAt || 500) + '</s></span></div>' +
        '<p class="cv-wrap__sub">' + (current ? 'Pick a color: ' + currentName : 'Tap a color to add it.') + '</p>' +
        '<div class="cv-wrap__colors" role="radiogroup" aria-label="Charger wrap color">';
      colors.forEach(function (w) {
        html += '<button type="button" class="cv-swatch-btn" role="radio" aria-checked="' + (Number(w.id) === currentId) + '" aria-label="' + w.title + '" data-cv-wrap-color="' + w.id + '" style="background:' + w.hex + '"></button>';
      });
      html += '</div></div>';
    }
    return html;
  }

  function renderExtras(cart) {
    if (!cart) return;
    var targets = [];
    var drawerHeader = document.querySelector('#CartDrawer .drawer__header');
    if (drawerHeader) targets.push({ el: drawerHeader, where: 'afterend' });
    var cartPage = document.querySelector('#main-cart-items .title-wrapper-with-link');
    if (cartPage) targets.push({ el: cartPage, where: 'afterend' });
    var html = extrasHTML(cart);
    targets.forEach(function (t) {
      var parent = t.el.parentNode;
      var old = parent.querySelector(':scope > .cv-cart-extras');
      if (old) old.remove();
      if (html) t.el.insertAdjacentHTML(t.where, '<div class="cv-cart-extras">' + html + '</div>');
    });
  }

  // Re-draw the extras whenever Dawn re-renders the drawer.
  var drawerEl = document.querySelector('#CartDrawer');
  if (drawerEl && window.MutationObserver) {
    var timer;
    new MutationObserver(function (records) {
      var ours = records.every(function (r) {
        return Array.prototype.every.call(r.addedNodes, function (n) { return n.classList && n.classList.contains('cv-cart-extras'); }) &&
          Array.prototype.every.call(r.removedNodes, function (n) { return n.classList && n.classList.contains('cv-cart-extras'); });
      });
      if (ours) return;
      clearTimeout(timer);
      timer = setTimeout(function () { getCart().then(renderExtras).catch(function () {}); }, 60);
    }).observe(drawerEl, { childList: true, subtree: true });
  }

  /* ---------- clicks ---------- */
  document.addEventListener('click', function (event) {
    var t = event.target instanceof Element ? event.target : null;
    if (!t) return;

    var cartSwatch = t.closest('[data-cv-wrap-color]');
    if (cartSwatch) {
      event.preventDefault();
      var box = cartSwatch.closest('[data-cv-wrap]');
      if (box) box.classList.add('is-loading');
      enqueue(function () {
        return chooseColor(Number(cartSwatch.getAttribute('data-cv-wrap-color'))).then(function (changed) {
          return changed ? refreshUI().then(getCart).then(tellTheme) : getCart().then(renderExtras);
        });
      });
      return;
    }

    var pdpSwatch = t.closest('[data-cv-pdp-wrap]');
    if (pdpSwatch) {
      event.preventDefault();
      var id = Number(pdpSwatch.getAttribute('data-cv-pdp-wrap'));
      store.set(COLOR_KEY, String(id));
      store.set(DECLINED_KEY, null);
      var group = pdpSwatch.closest('[data-cv-pdp-wraps]');
      if (group) {
        group.querySelectorAll('[data-cv-pdp-wrap]').forEach(function (b) { b.setAttribute('aria-checked', String(b === pdpSwatch)); });
        var name = document.querySelector('[data-cv-pdp-wrap-name]');
        if (name) name.textContent = pdpSwatch.getAttribute('aria-label');
      }
      // If a wrap is already in the bag, swap it to the new color.
      enqueue(function () {
        return getCart().then(function (cart) {
          if (!cart.items.some(isWrap)) return false;
          return chooseColor(id).then(function (changed) { if (changed) return refreshUI(); });
        });
      });
      return;
    }

    var more = t.closest('[data-cv-reviews-more]');
    if (more) {
      var sec = more.closest('.cv-reviews');
      if (sec) sec.classList.add('is-open');
    }
  });

  /* ---------- product page: show the remembered wrap color ---------- */
  function initPdp() {
    var group = document.querySelector('[data-cv-pdp-wraps]');
    if (!group) return;
    var chosen = preferredId();
    group.querySelectorAll('[data-cv-pdp-wrap]').forEach(function (b) {
      var on = Number(b.getAttribute('data-cv-pdp-wrap')) === chosen;
      b.setAttribute('aria-checked', String(on));
      if (on) {
        var name = document.querySelector('[data-cv-pdp-wrap-name]');
        if (name) name.textContent = b.getAttribute('aria-label');
      }
    });
  }

  window.addEventListener('pageshow', function (e) { if (e.persisted) afterCartChange(false); });

  function start() {
    initPdp();
    getCart().then(function (cart) {
      renderExtras(cart);
      if (cart.item_count > 0) afterCartChange(false);
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
